// accountApi.ts
import { adminApi, ApiAdminV1AccountsListApiArg } from '../../../../store/generated/admin/account';
import { UserContextApiTags } from '../../../../common/api/userContextApi';

export const AccountApiTags = { Accounts: 'Accounts' } as const;

type AccountsListQueryArg = ApiAdminV1AccountsListApiArg & {
  organization_id?: number;
};

export const accountApi = adminApi.enhanceEndpoints({
  addTagTypes: [
    AccountApiTags.Accounts,
    UserContextApiTags.UserContext,
    UserContextApiTags.OrganizationContext,
  ],
  endpoints: {
    apiAdminV1AccountsList: {
      providesTags: [AccountApiTags.Accounts],
      query: (queryArg: AccountsListQueryArg) => {
        const url = `/api/admin/v1/accounts/`;
        const params = new URLSearchParams();

        if (queryArg.id > 0) {
          params.set('id', String(queryArg.id));
        }
        if (queryArg.organization_id && queryArg.organization_id > 0) {
          params.set('organization_id', String(queryArg.organization_id));
        }

        return {
          url,
          params,
        };
      },
    },
    apiAdminV1AccountsCreate: {
      invalidatesTags: [
        AccountApiTags.Accounts,
        UserContextApiTags.UserContext,
      ],
    },
    apiAdminV1AccountsPartialUpdate: {
      invalidatesTags: [
        AccountApiTags.Accounts,
        UserContextApiTags.UserContext,
      ],
    },
    apiAdminV1AccountsToggleStatusCreate: {
      invalidatesTags: [
        AccountApiTags.Accounts,
        UserContextApiTags.UserContext,
      ],
    },
    apiAdminV1AccountsAddToOrganizationCreate: {
      invalidatesTags: [
        AccountApiTags.Accounts,
        UserContextApiTags.UserContext,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1AccountsDeleteAllCognitoUsersCreate: {
      invalidatesTags: [AccountApiTags.Accounts],
    },
  },
});
